import { render, staticRenderFns } from "./MenuStorePrincipal.vue?vue&type=template&id=2df9d110"
import script from "./MenuStorePrincipal.vue?vue&type=script&lang=js"
export * from "./MenuStorePrincipal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports